<template>
  <div class="page-container">
    <Header />
    <h1 class="titles">3D Printing</h1>
    <div v-for="project in projects" :key="project.title" class="page-element">
      <h2 class="titles">{{ project.title }}</h2>
      <div class="relic-row">
        <video v-if="project.video" class="relic-gif" autoplay muted loop playsinline :poster="project.image" :aria-label="project.imageAlt">
          <source :src="project.video.webm" type="video/webm">
          <source :src="project.video.mp4" type="video/mp4">
        </video>
        <img v-else-if="project.image" class="relic-gif" :src="project.image" :alt="project.imageAlt">
        <div>
          <p class="desc">{{ project.description }}</p>
          <h3 class="subtitle">What I made</h3>
          <ul class="desc">
            <li v-for="item in project.made" :key="item">{{ item }}</li>
          </ul>
          <button v-if="project.vault" class="vault-btn" @click="$router.push({ name: 'TheVault' })">Open The Vault</button>
        </div>
      </div>
    </div>
    <SiteFooter />
  </div>
</template>

<script>
import Header from './header.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import cursedFingerPoster from '@/assets/videos/cursed_finger-poster.jpg';
import cursedFingerWebm from '@/assets/videos/cursed_finger.webm';
import cursedFingerMp4 from '@/assets/videos/cursed_finger.mp4';

// One entry per printed project; add new ones to the list.
// draft: descriptions are for Florin to rewrite in his own words.
const projects = [
  {
    title: 'Cursed Relics',
    image: cursedFingerPoster,
    video: { webm: cursedFingerWebm, mp4: cursedFingerMp4 },
    imageAlt: 'Cursed Finger relic',
    description:
      'A limited run of 500 numbered, 3D-printed Cursed Fingers. Each one carries an NFC tag: tap it with a phone and it opens its own page, where the first owner awakens and claims the relic under their name.',
    made: [
      'The 3D model and the printed collectible',
      'An NFC tag per relic that links to its own claim page',
      'The claim website and a small backend that tracks all 500 relics'
    ],
    vault: true
  },
  {
    title: 'NFC review plaque',
    image: null,
    imageAlt: 'NFC review plaque',
    description:
      'A small 3D-printed plaque that sits on a restaurant table or counter. Customers tap their phone on it and the restaurant\'s Google Reviews page opens straight away, with no QR code to scan and no searching.',
    made: [
      'The 3D model and the printed plaque',
      'An NFC tag inside, set to open the restaurant\'s Google Reviews page'
    ],
    vault: false
  }
];

export default {
  name: 'ThreeDPrinting',
  components: { Header, SiteFooter },
  data() {
    return { projects };
  }
}
</script>

<style scoped lang="scss">
@use '../assets/styles/global.scss' as *;

.page-element {
  box-sizing: border-box;
  padding-top: 10px;
}
.relic-row {
  display: flex;
  gap: 32px;
  align-items: flex-start;
  margin-bottom: 30px;
}
.relic-gif {
  width: 280px;
  max-width: 100%;
  border-radius: 12px;
}
.desc {
  width: auto;
  max-width: 520px;
}
ul.desc {
  padding-left: 20px;
}
.vault-btn {
  margin-top: 12px;
  background-color: var(--purple);
  color: white;
  border: none;
  padding: 12px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 6px;
}
@media (max-width: 768px) {
  .relic-row {
    flex-direction: column;
  }
  .page-element {
    width: 100%;
    padding: 0 16px;
  }
}
</style>
